import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-metodo-pago',
  templateUrl: './modal-metodo-pago.component.html',
  styleUrls: ['./modal-metodo-pago.component.scss']
})
export class ModalMetodoPagoComponent {
  @Input() cssClass: string;
  @Input() onlyIcon: boolean = false;
  paymentForm: FormGroup;
  tipoPago: Array<any>;
  @Output() updateData = new EventEmitter();

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService) {
    this.initializeForm();
  }

  ngOnInit() {
    this.getMetodoPago();
  }

  initializeForm() {
    this.paymentForm = this.fb.group({
      fecha_pago: [this.Func.Today(true), Validators.required],
      id_tipopago: [null, Validators.required],
      tipoPagoText: [null],
      referencia: [null],
      total: [0, Validators.required],
    });
  }

  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      //Cerrado/guardado retornando objeto
      this.updateData.emit({
        fecha_pago: this.paymentForm.get("fecha_pago").value.split(" ")[0],
        hora_pago: this.paymentForm.get("fecha_pago").value.split(" ")[1],
        id_tipopago: this.paymentForm.get("id_tipopago").value,
        tipoPagoText: this.paymentForm.get("tipoPagoText").value,
        referencia: this.paymentForm.get("referencia").value,
        total: this.paymentForm.get("total").value
      });
      this.initializeForm();
    }, (reason) => {
      //Cerrasdo por X, ESC, backdrop
    });
  }

  getMetodoPago() {
    this.generalService.getListar("tipo_pago")
      .then(res => {
        this.tipoPago = res.data;
      })
      .catch(err => this.toastr.error('Error al obtener tipos de pago!'))
  }
}
